module.exports = __webpack_public_path__ + "img/sentra5.00e8d063.jpeg";